export type CraPresentationVariant = "legacy" | "zuu";

export function resolveCraPresentationVariant(input: {
  craVersion?: string | null;
}): CraPresentationVariant {
  if (input.craVersion?.startsWith("zuu.")) {
    return "zuu";
  }

  return "legacy";
}

export function isZuuCraVariant(input: {
  craVersion?: string | null;
}): boolean {
  return resolveCraPresentationVariant(input) === "zuu";
}
